export default __webpack_public_path__ + "static/media/icon_done_green_fill.38b90f80.svg";